module.exports = __webpack_public_path__ + "static/media/setting.e39e936b.svg";